import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Divider,
  Typography,
} from "@mui/material";
import Search from "./Search";
import SelectSearchOptions from "./SelectSearchOptions";
import { generateUrl } from "../helpers";

const BookSearch = ({
  activeStep,
  setActiveStep,
  citationData,
  setCitationData,
  setAuthors,
  selectedStyle,
  citationTab,
  selectedBook,
  setSelectedBook,
  handleBookTabChange,
}) => {
  const [localSelectedBook, setLocalSelectedBook] = useState(null);

  const handleNextStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBackStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  console.log("localSelectedBook:", localSelectedBook);

  const steps = [
    {
      label: "Search",
    },
    {
      label: "Select options",
    },
  ];
  const citationDataKeys = useMemo(() => {
    if (selectedBook && activeStep === 2) {
      return Object.keys(citationData);
    } else {
      // Return some default keys or an empty array based on your requirement
      return null;
    }
  }, [
    citationData.title,
    citationData.publisher,
    citationData.issued,
    citationData["publisher-place"],
    citationData.edition,
    citationData.ISBN,
    citationData.URL,
    citationData.type,
    citationData.author,
    selectedBook,
    selectedStyle,
    citationTab,
  ]);

  useEffect(() => {
    if (selectedBook && activeStep === 2) {
      let updatedCitationData = { ...citationData }; // Create a copy to avoid mutation
      //  console.log("citationDataKeys:", citationDataKeys);
      // Iterate over the keys of updatedCitationData
      citationDataKeys?.forEach((key) => {
        // Check if the key exists in selectedBook
        if (selectedBook.hasOwnProperty(key)) {
          // Update the value based on selectedBook
          updatedCitationData[key] = selectedBook[key] || "";
        }
      });

      if (citationDataKeys?.includes("URL")) {
        updatedCitationData.URL = generateUrl(selectedBook?.url_ids) || "";
      }
      setAuthors(selectedBook?.author);
      setCitationData(updatedCitationData);
    } else {
      // Reset values while keeping keys intact when there is no selectedBook
      setAuthors([
        {
          given: "",
          family: "",
        },
      ]);

      const resetCitationDataStructure = Object.keys(citationData)?.reduce(
        (acc, key) => {
          if (key === "issued") {
            // Create a new structure with a null value in the last array
            acc[key] = {
              "date-parts": [[null]],
            };
          } else if (key === "author") {
            acc[key] = [
              {
                given: "",
                family: "",
              },
            ];
          } else {
            // For other keys, set to an empty string or a default value
            acc[key] = ""; // or set to a default value based on your requirements
          }
          return acc;
        },
        {}
      );

      if (
        JSON.stringify(citationData) !==
        JSON.stringify(resetCitationDataStructure)
      ) {
        // The structures are not the same, so proceed with reset
        setCitationData(resetCitationDataStructure);
      }
    }
  }, [localSelectedBook, selectedBook, citationDataKeys, activeStep]);
  console.log("selectedBook", selectedBook);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "1rem",
      }}>
      {(activeStep === 0 || activeStep === 1) && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}>
          <Stepper
            sx={{ width: "75%" }}
            activeStep={activeStep}
            alternativeLabel>
            {steps?.map(({ label }, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      )}
      {activeStep === 0 && (
        <React.Fragment>
          <Search
            localSelectedBook={localSelectedBook}
            setLocalSelectedBook={setLocalSelectedBook}
            handleNextStep={handleNextStep}
          />
          {localSelectedBook && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}>
              <Button onClick={handleNextStep}>Next</Button>
            </Box>
          )}
          <Divider />
          <Box sx={{ textAlign: "center" }}>
            <Typography>or</Typography>
            <Button onClick={(e) => handleBookTabChange(e, "manual")}>
              Enter your citation details manually
            </Button>
          </Box>
        </React.Fragment>
      )}

      {activeStep === 1 && localSelectedBook && (
        <React.Fragment>
          <SelectSearchOptions
            localSelectedBook={localSelectedBook}
            setLocalSelectedBook={setLocalSelectedBook}
            handleBackStep={handleBackStep}
            handleFinishStep={handleNextStep}
            setSelectedBook={setSelectedBook}
          />

          <Divider />
          <Box sx={{ textAlign: "center" }}>
            <Typography>or</Typography>
            <Button onClick={(e) => handleBookTabChange(e, "manual")}>
              Enter your citation details manually
            </Button>
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
};

export default BookSearch;
